export default {"src":"/_next/static/media/oax.aab9acb8.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};